import React, { useEffect, useState } from 'react'
import SideBar from '../SideBar.js'
import Header from '../../Header/Header.js'
import BillingHeader from './BillingHeader.js'
import Table from "../../components/Table/index.jsx";
import { FaEye, FaTrash } from 'react-icons/fa6';
import { FaEdit } from 'react-icons/fa';

// const sampleData = [
//   {
//     id: 1,
//     weightAppliedDate: "2025-03-02",
//     awbNumber: "BD12345678",
//     orderId: "ORD987654",
//     enteredWeight: "2.5 kg",
//     appliedWeight: "3.0 kg",
//     weightCharges: "₹30",
//     product: "Smartphone",
//     status: "Delivered",
//   },
//   {
//     id: 2,
//     weightAppliedDate: "2025-03-01",
//     awbNumber: "DT98765432",
//     orderId: "ORD456789",
//     enteredWeight: "3.0 kg",
//     appliedWeight: "3.5 kg",
//     weightCharges: "₹40",
//     product: "Laptop",
//     status: "In Transit",
//   },
// ];

// Define Columns
const columns = [
  {
    name: <input type="checkbox" />,
    cell: (row) => <input type="checkbox" />,
    width: "50px",
  },
  { name: "Weight Applied Date", selector: (row) => row.weightAppliedDate, sortable: true, width: "180px" },
  { name: "AWB Number", selector: (row) => row.awbNumber, sortable: true },
  { name: "Order ID", selector: (row) => row.orderId, sortable: true },
  { name: "Entered Weight", selector: (row) => row.enteredWeight, sortable: true },
  { name: "Applied Weight", selector: (row) => row.appliedWeight, sortable: true },
  { name: "Weight Charges", selector: (row) => row.weightCharges, sortable: true },
  { name: "Product", selector: (row) => row.product, sortable: true },
  {
    name: "Status",
    selector: (row) => row.status,
    sortable: true,
    cell: (row) => (
      <span
        className={`px-2 py-1 rounded-lg ${row.status === "Delivered" ? "bg-green-500 text-white" : "bg-yellow-500 text-black"
          }`}
      >
        {row.status}
      </span>
    ),
  },
  {
    name: "Action",
    cell: (row) => (
      <div className="flex space-x-2">
        <button className="text-blue-500"><FaEye /></button>
        <button className="text-yellow-500"><FaEdit /></button>
        <button className="text-red-500"><FaTrash /></button>
      </div>
    ),
    width: "120px",
  },
];

const NewWeightReconciliation = () => {
  const [data, setData] = useState([]);



  return (
    <div>
      {/* Header */}
      <Header />

      <div className="flex min-h-screen bg-slate-100 overflow-hidden">
        {/* Sidebar */}
        <SideBar />

        <div className="flex-1 space-y-3 md:p-6 py-6 overflow-x-hidden ml-16">
          <BillingHeader />
          {/* Main Content */}

          <div className="mt-2 bg-white p-4 border rounded-lg">
            <Table
              columns={columns}
              data={data}
            // data={data = { data } || []}
            // currentPage={page}
            // totalRecords={GetOrderOrder?.getNDRList?.count || 0}
            // limit={limit}
            // setLimit={setLimit}
            // setPage={setPage}
            // loading={loading}
            // deleteData={DeleteProduct}
            // onSort={handleSort}
            // handlePagination={handlePagination}
            // multiSelectRow={onSelectedRowsChange}
            />
          </div>
        </div>
      </div>
    </div>

  )
}

export default NewWeightReconciliation
